export const actionTypes = {
  SET_MY_TODO_LIST: "SET_MY_TODO_LIST",
  SET_PROJECT_HISTORY_BY_TARGET: "SET_PROJECT_HISTORY_BY_TARGET",
  SET_PRODUCT_CASE_HISTORY_BY_TARGET: "SET_PRODUCT_CASE_HISTORY_BY_TARGET",
  SET_PROJECT_BY_TARGET: "SET_PROJECT_BY_TARGET",
  SET_PRODUCT_CASE_BY_TARGET: "SET_PRODUCT_CASE_BY_TARGET",
  SET_PRODUCT_BY_TARGET: "SET_PRODUCT_BY_TARGET",
  SET_PRODUCT_HISTORY_BY_TARGET: "SET_PRODUCT_HISTORY_BY_TARGET",
  SET_QUOTATION_RELEASE_BY_TARGET: "SET_QUOTATION_RELEASE_BY_TARGET",
  SET_QUOTATION_RELEASE_HISTORY_BY_TARGET: "SET_QUOTATION_RELEASE_HISTORY_BY_TARGET",
  SET_TODO_HISTORY_LIST_GET: "SET_TODO_HISTORY_LIST_GET",
  SET_DOC_DETAIL_BY_TARGET: "SET_DOC_DETAIL_BY_TARGET",
  SET_FAQ_DETAIL_BY_TARGET: "SET_FAQ_DETAIL_BY_TARGET",
  SET_GLOBAL_TODO_LIST: "SET_GLOBAL_TODO_LIST",
};